<script lang="ts">
    import ThemeToggle from "$components/misc/ThemeToggle.svelte";
    import LanguageToggle from "$components/misc/LanguageToggle.svelte";
    import { duoLang } from "$lib/state/duo-lang";
</script>

<div class="duo-brand-container">
    <!-- Barra superior con Selector de Idioma (ES / EN) y Switch de Tema -->
    <div class="top-utility-bar">
        <div class="utility-spacer"></div>
        <div class="utility-controls">
            <LanguageToggle />
            <ThemeToggle />
        </div>
    </div>

    <!-- Héroe Corporativo: Logo Puro (Sin caja negra) + Título Grande Descargas Duo -->
    <div class="brand-hero">
        <img
            src="/duo-logo.png"
            alt="Duo Creative Labs"
            class="duo-logo-img"
        />
        <div class="brand-text-block">
            <h1 class="brand-title">
                {#if $duoLang === "es"}
                    <span class="title-main">Descargas</span>
                    <span class="title-accent">Duo</span>
                {:else}
                    <span class="title-main">Duo</span>
                    <span class="title-accent">Downloads</span>
                {/if}
            </h1>
            <p class="brand-tagline">
                {#if $duoLang === "es"}
                    Guarda videos y audios en alta calidad (hasta 4K / 1080p)<br class="desktop-br" />
                    sin publicidad invasiva, marcas de agua ni límites.
                {:else}
                    Save videos and audio in high quality (up to 4K / 1080p)<br class="desktop-br" />
                    with no ads, watermarks, or limits.
                {/if}
            </p>
        </div>
    </div>

    <!-- Plataformas Soportadas: Texto limpio y sutil con LinkedIn (Sin cápsulas ni emojis) -->
    <div class="supported-platforms-bar">
        <span class="platform-item">YouTube</span>
        <span class="platform-dot">·</span>
        <span class="platform-item">Instagram Reels</span>
        <span class="platform-dot">·</span>
        <span class="platform-item">TikTok</span>
        <span class="platform-dot">·</span>
        <span class="platform-item">Twitter / X</span>
        <span class="platform-dot">·</span>
        <span class="platform-item">LinkedIn</span>
        <span class="platform-dot">·</span>
        <span class="platform-item">Facebook</span>
    </div>

    <!-- Bloque Lead Magnet Directo y Ejecutivo -->
    <div class="duo-lead-magnet-card">
        <div class="lm-header">
            <span class="lm-tag">
                {#if $duoLang === "es"}
                    DUO CREATIVE LABS · SISTEMAS & AGENTES IA
                {:else}
                    DUO CREATIVE LABS · AI AGENTS & SYSTEMS
                {/if}
            </span>
        </div>
        <h2 class="lm-title">
            {#if $duoLang === "es"}
                Automatiza los procesos de tu negocio con Inteligencia Artificial
            {:else}
                Automate your business workflows with Artificial Intelligence
            {/if}
        </h2>
        <p class="lm-desc">
            {#if $duoLang === "es"}
                <strong>Duo Creative Labs</strong> ayuda a tu empresa a automatizar procesos repetitivos y atención a clientes en WhatsApp y Telegram. Creamos agentes inteligentes que resuelven tu operación para darte más tiempo libre y multiplicar tus ventas.
            {:else}
                <strong>Duo Creative Labs</strong> helps your company automate repetitive tasks and customer service on WhatsApp and Telegram. We build intelligent agents that streamline your operations to give you back time and scale revenue.
            {/if}
        </p>
        <div class="lm-buttons">
            <a href="https://cal.com/duo-creative-labs/30min" target="_blank" rel="noopener noreferrer" class="btn-cta primary">
                <span>
                    {#if $duoLang === "es"}
                        Agendar asesoría gratuita
                    {:else}
                        Book a free strategy call
                    {/if}
                </span>
            </a>
            <a href="https://www.instagram.com/duolabs.tech/" target="_blank" rel="noopener noreferrer" class="btn-cta secondary">
                <span>
                    {#if $duoLang === "es"}
                        Síguenos en Instagram
                    {:else}
                        Follow on Instagram
                    {/if}
                </span>
            </a>
        </div>
    </div>
</div>

<style>
    .duo-brand-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        width: 100%;
        max-width: 640px;
        box-sizing: border-box;
    }

    .top-utility-bar {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        margin-bottom: 12px;
    }

    .utility-spacer {
        flex: 1;
    }

    .utility-controls {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    /* Héroe Corporativo: Logo Grande + Título y Subtítulo en 2 Líneas Justificado a la Izquierda */
    .brand-hero {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 22px;
        margin-bottom: 20px;
        text-align: left;
        width: 100%;
    }

    .duo-logo-img {
        width: 96px;
        height: 96px;
        object-fit: contain;
        flex-shrink: 0;
        filter: drop-shadow(0 0 18px rgba(241, 190, 72, 0.45));
        transition: transform 0.25s ease, filter 0.25s ease;
    }

    .duo-logo-img:hover {
        transform: scale(1.05);
        filter: drop-shadow(0 0 26px rgba(241, 190, 72, 0.7));
    }

    .brand-text-block {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        text-align: left;
        gap: 6px;
    }

    .brand-title {
        margin: 0;
        font-size: 42px;
        font-weight: 700;
        letter-spacing: -1px;
        line-height: 1.05;
        text-align: left;
    }

    .title-main {
        color: var(--secondary);
    }

    .title-accent {
        color: #F1BE48;
    }

    .brand-tagline {
        margin: 0;
        color: var(--gray);
        font-size: 14.5px;
        font-weight: 400;
        line-height: 1.45;
        text-align: left;
        max-width: 460px;
    }

    .desktop-br {
        display: inline;
    }

    /* Plataformas Soportadas: Fila sutil con LinkedIn (Blue line 1: más aire con margin-bottom: 34px) */
    .supported-platforms-bar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        gap: 8px 12px;
        margin-bottom: 34px;
        padding: 0 4px;
    }

    .platform-item {
        font-size: 12.5px;
        font-weight: 500;
        color: var(--gray);
        letter-spacing: 0.2px;
        transition: color 0.15s ease;
    }

    .platform-item:hover {
        color: var(--secondary);
    }

    .platform-dot {
        color: var(--gray);
        opacity: 0.35;
        font-size: 12px;
        user-select: none;
    }

    /* Lead Magnet Card (Negro Puro #080808 + Blue line 2: más aire con margin-bottom: 38px) */
    .duo-lead-magnet-card {
        width: 100%;
        box-sizing: border-box;
        padding: 22px 24px;
        border-radius: 14px;
        margin-bottom: 38px;
        text-align: left;
        background: #080808;
        border: 1px solid rgba(255, 255, 255, 0.08);
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    :global([data-theme="dark"]) .duo-lead-magnet-card {
        background: #080808 !important;
        border: 1px solid rgba(241, 190, 72, 0.28) !important;
        box-shadow: 0 4px 28px rgba(0, 0, 0, 0.95);
    }

    :global([data-theme="light"]) .duo-lead-magnet-card {
        background: #ffffff !important;
        border: 1px solid rgba(0, 0, 0, 0.09) !important;
        box-shadow: 0 4px 18px rgba(0, 0, 0, 0.04);
    }

    .lm-header {
        margin-bottom: 8px;
    }

    .lm-tag {
        font-size: 11px;
        font-weight: 700;
        color: #F1BE48;
        letter-spacing: 1.2px;
        text-transform: uppercase;
        display: inline-block;
    }

    .lm-title {
        margin: 0 0 10px 0;
        font-size: 18px;
        font-weight: 600;
        line-height: 1.35;
        color: var(--secondary);
    }

    .lm-desc {
        margin: 0 0 18px 0;
        font-size: 13.5px;
        font-weight: 400;
        line-height: 1.55;
        color: var(--gray);
    }

    .lm-desc strong {
        color: var(--secondary);
        font-weight: 600;
    }

    .lm-buttons {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
    }

    .btn-cta {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        text-decoration: none;
        letter-spacing: 0.1px;
        transition: all 0.18s ease;
        box-sizing: border-box;
        cursor: pointer;
    }

    .btn-cta.primary {
        background: #F1BE48;
        color: #10100F;
        border: 1px solid #F1BE48;
    }

    .btn-cta.primary:hover {
        background: #ffc955;
        border-color: #ffc955;
        transform: translateY(-1px);
        box-shadow: 0 4px 14px rgba(241, 190, 72, 0.35);
    }

    .btn-cta.secondary {
        background: transparent;
        color: var(--secondary);
        border: 1px solid var(--button-stroke);
    }

    :global([data-theme="dark"]) .btn-cta.secondary {
        background: rgba(255, 255, 255, 0.04);
        border-color: rgba(255, 255, 255, 0.12);
    }

    :global([data-theme="light"]) .btn-cta.secondary {
        background: #f7f7f8;
        border-color: rgba(0, 0, 0, 0.1);
    }

    .btn-cta.secondary:hover {
        transform: translateY(-1px);
        border-color: #F1BE48;
        color: var(--secondary);
    }

    /* Adaptación 100% Mobile Responsive */
    @media screen and (max-width: 600px) {
        .desktop-br {
            display: none;
        }

        .brand-hero {
            flex-direction: column;
            text-align: center;
            gap: 12px;
        }

        .brand-text-block {
            align-items: center;
            text-align: center;
        }

        .brand-title {
            font-size: 32px;
        }

        .brand-tagline {
            font-size: 13px;
        }

        .duo-logo-img {
            width: 80px;
            height: 80px;
        }

        .supported-platforms-bar {
            gap: 6px 8px;
            font-size: 11.5px;
            margin-bottom: 22px;
        }

        .duo-lead-magnet-card {
            padding: 18px 16px;
            text-align: center;
        }

        .lm-title {
            font-size: 15.5px;
        }

        .lm-desc {
            font-size: 12.5px;
        }

        .lm-buttons {
            flex-direction: column;
            width: 100%;
            gap: 8px;
        }

        .btn-cta {
            width: 100%;
        }
    }
</style>
